export enum PaymentTypeEnum {
  Cash = 'CASH',
  CreditCard = 'CC',
  Invoice = 'INV',
}
